import { TAppState } from '../../types/appState';

export function userIdSelector(state: TAppState) {
  return state.user.userId;
}
